<div class="header__lang">
  <div class="dropdown" [class.header__erp-mode-dev-text]="erpMode">
    <button type="button" data-bs-toggle="dropdown" id="dropdownMenuLang">
      {{ selectedLang | uppercase }}
    </button>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLang">
      <li>
        <a
          *ngFor="let lang of headerLanguages"
          (click)="setLanguage(lang)"
          class="dropdown-item link"
        >
          {{ lang | uppercase }}
        </a>
      </li>
    </ul>
  </div>
</div>
